import { render } from "./ZellePaymentRequestTable.vue?vue&type=template&id=0b9bd69a&scoped=true"
import script from "./ZellePaymentRequestTable.vue?vue&type=script&lang=js"
export * from "./ZellePaymentRequestTable.vue?vue&type=script&lang=js"

import "./ZellePaymentRequestTable.vue?vue&type=style&index=0&id=0b9bd69a&scoped=true&lang=scss"

import exportComponent from "/var/www/gl_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9bd69a"]])

export default __exports__